"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiTextField = function MuiTextField() {
  return {
    root: {
      '& [class*="MuiSelect-root"]': {
        '& svg': {
          visibility: 'hidden'
        }
      }
    }
  };
};

var _default = MuiTextField;
exports["default"] = _default;